import gql from 'graphql-tag';

// Query
export const Qoperation = 'DealLeadFinalizedInvestors';
export const query = gql`
  query ${Qoperation}($dealId: ID!) {
    deal(id: $dealId) {
      id
      self
      metrics {
        allocation
      }
      allocations {
        id
        self
        documents {
          signed
        }
        investment {
          amount
          allocated
          funded
        }
        owner {
          firstName
          lastName
          image
          self
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/finalized/index.js